import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#05050A] text-white grid place-items-center px-6">
      <div className="max-w-md w-full text-center p-8 md:p-10 glass rounded-3xl border border-white/10">
        <XCircle className="mx-auto text-white/40" size={48} />
        <h1 className="font-[Unbounded] text-2xl mt-6">Checkout cancelled</h1>
        <p className="text-white/60 mt-3">No charge was made. You&rsquo;re still on the Free tier — come back any time to upgrade.</p>
        <Link data-testid="pay-cancel-back-btn" to="/profile" className="inline-flex items-center gap-2 mt-8 bg-white/5 border border-white/10 text-white font-semibold px-6 py-3 rounded-full hover:border-[#00E5FF] transition-all">
          <ArrowLeft size={16} /> Back to profile
        </Link>
      </div>
    </div>
  );
}
